import { FormField, TextInput } from '@compono/ui';
import React, { ChangeEvent, FC, KeyboardEvent, useState } from 'react';

interface SkillNameInputProps {
  value: string;
  onChange: (name: string) => void;
  onPressEnter?: () => void;
  showError?: boolean;
}

const SkillNameInput: FC<SkillNameInputProps> = ({
  onChange,
  onPressEnter,
  value,
  showError = true,
}) => {
  const [name, setName] = useState(value);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    setName(newValue);
    onChange(newValue);
  };

  return (
    <FormField
      fieldId="skillName"
      label="Skill name"
      error={!name.trim() && showError ? 'Skill name is required' : undefined}
    >
      <TextInput
        id="skillName"
        placeholder={'e.g. PHP'}
        defaultValue={name}
        onChange={handleChange}
        onKeyPress={(e: KeyboardEvent) => {
          if (e.key === 'Enter' && onPressEnter) {
            onPressEnter();
          }
        }}
      />
    </FormField>
  );
};

export default SkillNameInput;
